module.exports = __webpack_public_path__ + "img/inst-solar.8193de1f.jpg";